import { Injectable, Inject } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ResolutionService {
  medias = {
    SM: 360,
    MD: 768,
    LG: 1115,
  };

  screenWidth: number;

  constructor(@Inject('Window') private readonly window: Window) {
    this.getScreenSize();
  }

  getScreenSize() {
    this.screenWidth = this.window.screen.width;
  }

  get isMobile() {
    return this.screenWidth < this.medias.MD;
  }

  get isTablet() {
    return this.screenWidth < this.medias.LG;
  }
}
